import { noop } from 'utils'
import { useDispatch } from 'react-redux'
import { Dialogs } from './dialogSlice'
import Dialog from './Dialog'
import PropTypes from 'prop-types'
import { memo, useCallback, useMemo, useRef } from 'react'
import {
  getLastDialogIndex,
  useCreateDialogHook,
} from 'features/dialog/dialogHookFactory'
import Button from 'components/form/Button'
import { useUpdatingRef } from 'utils/hooks/useUpdatingRef'

const Alert = memo(
  ({
    id,
    title,
    confirmText = '확인',
    onOpen = noop,
    onClose = noop,
    children,
    changeLayoutClass = true,
  }) => {
    const confirmRef = useRef()
    const onOpenRef = useUpdatingRef(onOpen)
    const dispatch = useDispatch()
    const close = () => {
      onClose({ isConfirmed: true })
      dispatch(Dialogs.hide(id))
    }

    const innerOnOpen = useCallback(() => {
      confirmRef.current.focus()
      onOpenRef.current()
    }, [confirmRef, onOpenRef])

    return (
      <Dialog
        id={id}
        onOpen={innerOnOpen}
        onClose={onClose}
        changeLayoutClass={changeLayoutClass}>
        {title && <strong className="tit_layer">{title}</strong>}
        <p className="txt_layer">{children}</p>
        <div className="btn_group">
          <Button primary size="medium" ref={confirmRef} onClick={close}>
            {confirmText}
          </Button>
        </div>
      </Dialog>
    )
  }
)
Alert.displayName = 'Alert'
Alert.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  title: PropTypes.string,
  confirmText: PropTypes.node,
  changeLayoutClass: PropTypes.bool,
}

export const useAlert = (changeLayoutClass = true) =>
  useCreateDialogHook(
    Alert,
    useMemo(() => getLastDialogIndex(), []),
    changeLayoutClass
  )
